import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-attention-alert',
  templateUrl: './attention-alert.component.html',
  styleUrls: ['./attention-alert.component.scss'],
})
export class AttentionAlertComponent implements OnInit {
  @Input() message: string = ''

  constructor() { }

  ngOnInit(): void {
  }
}
